module.exports = __webpack_public_path__ + "models/speaker_e9e0f22effc94789a1c5dca76e2b78f9.glb";